export default __webpack_public_path__ + "static/media/ok-icon.94801a4d.svg";